import React, { useContext } from "react";
import { Checkbox } from "@material-ui/core";
import { CartContext } from "../../contexts/CartContext";

const DonationSetting = ({ donationSetting }) => {
    const { setDonationSettings, total, donationSettings, calculateProcessingFee } = useContext(CartContext);
    if (!donationSettings) return null;

    const selected = !!donationSettings.isSelected;
    const fee = calculateProcessingFee(donationSettings.rate);
    const displayedTotal = selected ? total : total + fee;
    const text = selected ? donationSetting.afterText : donationSetting.beforeText;
    const label = (text || "")
        .replaceAll("${totalAmount}", displayedTotal.toFixed(2))
        .replaceAll("${donationFee}", donationSettings.rate)
        .replaceAll("[DonationProcessingRate]", `${Number(donationSettings.rate).toFixed(2)}%`)
        .replaceAll("[DonationProcessingAmount]", `$${fee.toFixed(2)}`)
        .replaceAll("${AdditionalDonationAmount}", `$${fee.toFixed(2)}`);

    return (
        <div className="question-form-answer">
            <Checkbox checked={selected} onChange={event => setDonationSettings({
                ...donationSettings,
                isSelected: event.target.checked,
                price: fee.toFixed(2),
            })} /> {label}
        </div>
    );
};

export default DonationSetting;
